// TermsAndConditions.jsx
import React from "react";
import { motion } from "framer-motion";

const TermsAndConditions = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-4xl mx-auto p-6 sm:p-8"
    >
      <h1 className="text-2xl font-bold text-center mb-2">Terms & Conditions</h1>
      <p className="text-center text-sm text-gray-500 mb-8">
        IRYAX HIRE • Last Updated: July 2026
      </p>

      <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
        <p>
          By creating an account and using IRYAX HIRE, you agree to these Terms & Conditions. If you do not agree, please do not use our platform.
        </p>

        <div>
          <h2 className="text-lg font-semibold mb-2">1. Account Responsibility</h2>
          <p>
            You are responsible for keeping your account credentials confidential. All activities under your account are your responsibility.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-2">2. Job Applications</h2>
          <p>
            All applications must be genuine and truthful. Misrepresentation may result in account suspension or legal action.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-2">3. Coin Rewards System</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Apply for Job - 20 Coins</li>
            <li>Complete Assessment - 10 Coins</li>
            <li>Attend Interview - 50 Coins</li>
            <li>Get Selected/Hired - 100 Coins</li>
            <li>Refer a Friend - 200 Coins</li>
            <li>Complete Profile - 30 Coins</li>
            <li>Share Job Posting - 15 Coins</li>
          </ul>
          <p className="mt-2 text-xs text-gray-400">Coins are non-transferable and have no cash value.</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-2">4. Coin Purchase & Refund Policy</h2>
          <p className="mb-2">
            Users can purchase additional coins through the platform to continue using services such as applying for jobs, taking assessments, and other activities.
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Coin purchases are made through secure payment gateways</li>
            <li>Purchased coins are credited to your account instantly</li>
            <li>Coins can be used for all platform activities including job applications, assessments, and interviews</li>
          </ul>
          
          <h3 className="font-semibold mt-3 mb-1">Refund Policy:</h3>
          <ul className="list-disc pl-5 space-y-1">
            <li>Users can request a refund for purchased coins within <strong>7 days</strong> of purchase</li>
            <li>Refund requests must be sent to <strong>info@ingrainsystem.com</strong> with subject "Coin Refund Request"</li>
            <li>Refund will be processed only if the purchased coins are <strong>completely unused</strong></li>
            <li>If any coins have been used (even partially), the refund will not be applicable</li>
            <li>Refund will be credited to the original payment source within 5-7 business days</li>
            <li>Any transaction fees or gateway charges will be deducted from the refund amount</li>
            <li>Earned coins through platform activities (rewards) are non-refundable and cannot be converted to cash</li>
          </ul>
          <p className="mt-2 text-xs text-amber-600 bg-amber-50 p-2 rounded border border-amber-200">
            ⚠️ Important: Refund requests after 7 days of purchase will not be entertained under any circumstances.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-2">5. Termination</h2>
          <p>
            We reserve the right to suspend or terminate accounts that violate these terms. You may delete your account by contacting support.
          </p>
          <p className="mt-1 text-xs text-gray-400">
            Note: Upon account termination, unused purchased coins may be refunded as per the refund policy above. Earned coins will be forfeited.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-2">6. Disclaimer</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>We do not guarantee job placement or interview success</li>
            <li>Platform is provided "as is" without warranties</li>
            <li>We are not liable for any indirect or consequential damages</li>
          </ul>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-2">7. Contact Us</h2>
          <p>Email: info@ingrainsystem.com</p>
          <p>Phone: +91-9010481048</p>
        </div>

        <div className="border-t pt-4 mt-4 text-center text-xs text-gray-400">
          © {new Date().getFullYear()} IRYAX HIRE • All Rights Reserved
        </div>
      </div>
    </motion.div>
  );
};

export default TermsAndConditions;